import _ from 'lodash';
import classnames from 'classnames';
import { PaymentMethodCreateParams } from '@stripe/stripe-js';
import { useTranslation } from 'react-i18next';

import SelectInputRow from './SelectInputRow';
import TextInputRow from './TextInputRow';

import { formRows } from './config';
import styles from '../index.module.css';

interface Props {
  billingDetails: PaymentMethodCreateParams.BillingDetails;
  setBillingDetails: (value: PaymentMethodCreateParams.BillingDetails) => void;
}

const BillingDetailsForm: React.FC<Props> = ({
  billingDetails,
  setBillingDetails,
}) => {
  const { t } = useTranslation();
  return (
    <>
      <div className={classnames(styles.BillingHeader, styles.HeaderLabel)}>
        {t('Add your billing information')}
      </div>
      <div className={styles.Form}>
        {formRows.map((entry, idx) => {
          const commonProps = {
            key: `bdf-${idx}`,
            label: t(entry.label),
            value: _.get(billingDetails, entry.field, ''),
          };
          const onChange = (value: string) => {
            const copy = {
              ...billingDetails,
              address: { ...billingDetails.address },
            };
            _.set(copy, entry.field, value);
            setBillingDetails(copy);
          };

          switch (entry.type) {
            case 'select':
              if (entry.label === 'Country') {
                return null;
              }
              return (
                <SelectInputRow
                  {...commonProps}
                  options={entry.options}
                  onChange={onChange}
                />
              );
            case 'number':
            case 'text':
              return (
                <TextInputRow
                  {...commonProps}
                  type={entry.type}
                  onChange={(e) => {
                    if (
                      entry.validationRegex &&
                      entry.validationRegex.exec(e.currentTarget.value) === null
                    ) {
                      return;
                    }
                    onChange(e.target.value);
                  }}
                  placeholder={entry.placeholder}
                />
              );
            default:
              return null;
          }
        })}
      </div>
    </>
  );
};

export default BillingDetailsForm;
